// extracted by mini-css-extract-plugin
module.exports = {"name":"styles_name__3aw-z","circle":"styles_circle__27GEa","blue":"styles_blue__2IxRI"};